function cov_hgnyifubm() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/index.ts";
  var hash = "883a4eaa8cfc30ef36a7e8ea47d91bd450aaf2b5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "883a4eaa8cfc30ef36a7e8ea47d91bd450aaf2b5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_hgnyifubm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_hgnyifubm();
export { PropertyCard } from "./PropertyCard.mjs";
//# sourceMappingURL=index.mjs.map